var map = {
	"./2021/2021-paper1-4mark.json": 6189,
	"./2021/2021-paper2-4mark.json": 6084,
	"./2022/2022-paper1-4mark.json": 1611,
	"./2022/2022-paper2-4mark.json": 8262,
	"./2023/2023-paper1-4mark.json": 8613,
	"./2023/2023-paper2-4mark.json": 4860,
	"./2024/2024-paper1-4mark.json": 5207,
	"./2024/2024-paper2-4mark.json": 1154,
	"./2025/2025-paper1-4mark.json": 6693,
	"./2025/2025-paper2-4mark.json": 7628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1168;